module.exports = __webpack_public_path__ + "img/examCard.bb67edf1.png";